module.exports = __webpack_public_path__ + "static/media/20201129_221553_126_IMG_1942.358c2088.jpg";